function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useEffect, useState } from "react";
import useData from "../PropertyMapView/data";
import React from "react";
import AccordianNew from "../../../Common/Accordian";
import SingleGMaps from "../../Molecules/Map/singleGmaps";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function ProjectLocationNew(_ref) {
  var _config$deals$darkThe;
  var projectId = _ref.projectId,
    projectDetails = _ref.projectDetails,
    highlightCategories = _ref.highlightCategories,
    projectAdditionalHighlights = _ref.projectAdditionalHighlights,
    config = _ref.config;
  console.log("anmol malik");
  var _useData = useData(projectId),
    lng = _useData.lng,
    lat = _useData.lat,
    viewport = _useData.viewport,
    setViewport = _useData.setViewport;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    location = _useState2[0],
    setLocation = _useState2[1];
  useEffect(function () {
    if (projectDetails.projectLocation !== null) setLocation(projectDetails.projectLocation);
  }, [projectDetails]);
  var _useState3 = useState(highlightCategories),
    _useState4 = _slicedToArray(_useState3, 2),
    highlights = _useState4[0],
    setHighlights = _useState4[1];
  useEffect(function () {
    if (highlightCategories !== highlights && highlightCategories.length !== 0) setHighlights(highlightCategories);
    if (projectAdditionalHighlights !== undefined) {
      var _additional;
      var additional = [];
      Object.values(projectAdditionalHighlights).map(function (addHigh) {
        addHigh[0] = _objectSpread(_objectSpread({}, addHigh[0]), {}, {
          name: addHigh[0].title
        });
        additional = [].concat(_toConsumableArray(additional), _toConsumableArray(addHigh));
      });
      if (((_additional = additional) === null || _additional === void 0 ? void 0 : _additional.length) > 0) highlightCategories["Additional Highlights"] = additional;
      setHighlights(highlightCategories);
    }
  }, [highlightCategories, projectAdditionalHighlights]);
  return /*#__PURE__*/_jsx("div", {
    id: "location_highlights",
    className: "flex flex-col mt-8",
    children: /*#__PURE__*/_jsxs("div", {
      className: "z-20 text-black  ",
      children: [/*#__PURE__*/_jsx("div", {
        className: "w-full flex flex-col",
        children: /*#__PURE__*/_jsx("h4", {
          className: "z-10 ".concat(config !== null && config !== void 0 && config.darkMode ? (config === null || config === void 0 || (_config$deals$darkThe = config.deals.darkTheme) === null || _config$deals$darkThe === void 0 ? void 0 : _config$deals$darkThe.text) || "text-primary" : "text-[#130E2F]", " text-xl font-bold ").concat(config.fontTitle),
          children: "Location Highlight"
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: " ".concat(config.fontBody, " grid grid-cols-1 lg:grid-cols-2 mt-4"),
        children: [projectDetails.projectLocation !== null && /*#__PURE__*/_jsx(SingleGMaps, {
          location: location,
          viewport: viewport,
          setViewport: setViewport,
          projectName: projectDetails.projectName,
          projectPrice: projectDetails.price,
          projectCity: projectDetails.city,
          config: config
        }), Object.keys(highlights).length === 0 && /*#__PURE__*/_jsx("p", {
          className: "".concat(projectDetails.projectLocation !== null ? "m-6 text-center " : " text-left", " text-lg ").concat(config !== null && config !== void 0 && config.darkMode ? "text-base-content" : "text-[#130E2F]"),
          children: "Soon updating with all facilities in vicinity"
        }), Object.keys(highlights).length >= 1 && /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(AccordianNew, {
            highlightCategories: highlights
          })
        })]
      })]
    })
  });
}